import AlertStore from './alert.store'
import PromtStore from './prompt.store'
import AddCropStore from './add-crop.store'

export default {
  namespaced: true,
  modules: {
    'alert': AlertStore,
    'prompt': PromtStore,
    'add-crop': AddCropStore,
  },
  state: {

  },
  mutations: {

  },
  actions: {
    closeAll(context) {
      console.log(context.state);
    }
  },
  getters: {

  }
};;
